module.exports = __webpack_public_path__ + "img/profissionais-pec-cnes.2e41d61b.svg";